<ng-container *ngIf="showLoading">
    <div class="w-100 float-left v-align relative" (click)="clicked();closeEmployeeFilter()">
        <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
            <h5 class="medium m-0">{{employeeDetails.displayName}} ({{employeeDetails.empCode}})</h5>
            <div style="flex-grow: 1;"></div>
            <button class="btn btn-secondary float-right mr-4" (click)="_location.back()">
                <i class="fa fa-arrow-left mr-sm-2"></i> {{'back' | translate}}
            </button>
            <button class="btn btn-primary float-right mr-4 " (click)="switchToAddSwitchableUsers()"> {{'addUsers' |
                translate}}
            </button>
            <button class="btn btn-secondary float-right mr-4" *ngIf="employeeIdStrList.length > 0"
                    (click)="removeSelectedEmpPermission()">
                {{'removePermission' | translate}}
            </button>
            <button class="btn btn-secondary float-right mr-4" *ngIf="employeeIdStrList.length > 0 && totalCount > 10"
                    (click)="removeAllEmpPermission()"> {{'remove' | translate}} {{totalCount}} {{'userPermission' |
                translate}}
            </button>
        </div>
    </div>

    <div (click)="clicked()" *ngIf="switchableUsersCount > 0">
        <employeeFilter [displayTab]="'employeeSearch'" (searchEmp)="showSearchFilter($event)"></employeeFilter>
    </div>
    <ng-container *ngIf="switchPage == 'selectSwitchableUsers'">
        <!-- EMPLOYEE DETAILS GRID -->
        <div class="w-100 float-left mt-4" (click)="closeEmployeeFilter()">
            <div class="light-bg w-100 float-left p-2 grid-details" *ngIf="switchableUsersCount > 0">
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center" (click)="selectAll()">
                    <div class="checkbox checkbox-primary">
                        <input id="selectedAllSwitchAble" type="checkbox" [(ngModel)]="selectedAllSwitchAble">
                        <label for="selectedAllSwitchAble" class="mb-md-0"></label>
                    </div>

                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 medium">{{'empID' | translate}} </h6>
                </div>
                <div class="col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 medium"> {{'name' | translate}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                    <h6 class="mb-lg-0 medium"> {{'orgUnit' | translate}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                    <h6 class="mb-lg-0 medium"> {{'designation' | translate}} </h6>
                </div>
            </div>
            <ng-container *ngIf="switchableUsersCount > 0">
                <div class="w-100 float-left p-md-2 grid-details" *ngFor="let user of switchableUsers;index as i">
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                        <div class="checkbox checkbox-primary">
                            <input id="checkbox{{i}}" type="checkbox" [(ngModel)]="user.isChecked"
                                   (click)="unSelect($event,user)">
                            <label for="checkbox{{i}}" class="mb-md-0"></label>
                        </div>
                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                        <h6 class="mb-lg-0 text-truncate" *ngIf="user.employeeCode != null"> {{user.employeeCode}} </h6>
                        <h6 class="mb-lg-0 text-truncate" *ngIf="user.employeeCode == null"> {{'notAvailable' |
                            translate}} </h6>
                    </div>
                    <div class="col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left">
                        <h6 class="mb-lg-0 text-truncate" *ngIf="user.employeeCode != null"> {{user.displayName}} </h6>
                        <h6 class="mb-lg-0 text-truncate" *ngIf="user.employeeCode == null"> {{'notAvailable' |
                            translate}} </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                        <h6 class="mb-lg-0 text-truncate" *ngIf="user.employeeCode != null"> {{user.organizationName}}
                        </h6>
                        <h6 class="mb-lg-0 text-truncate" *ngIf="user.employeeCode == null"> {{'notAvailable' |
                            translate}} </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                        <h6 class="mb-lg-0 text-truncate" *ngIf="user.employeeCode != null"> {{user.designation}} </h6>
                        <h6 class="mb-lg-0 text-truncate" *ngIf="user.employeeCode == null"> {{'notAvailable' |
                            translate}} </h6>
                    </div>


                </div>
            </ng-container>
            <ng-container *ngIf="switchableUsersCount == 0">
                <p class="text-center m-0 w-100 medium">{{'noEmployeeFound' | translate}}</p>
            </ng-container>
        </div>

        <!-- PAGINATION -->
        <div class="w-100 float-left my-4 light-bg p-3 align-v-center" *ngIf="switchableUsersCount > 0"
             (click)="clicked();closeEmployeeFilter()">
            <h6 class="float-left mb-0 mr-2"> {{startCount}}- {{endCount}} {{'itemsOf' | translate}} {{totalCount}}
            </h6>
            <div style="flex-grow: 1;"></div>
            <ngb-pagination [collectionSize]="totalCount" [(page)]="page" [maxSize]="5" [rotate]="true"
                            [ellipses]="false"
                            [boundaryLinks]="true" class="float-right"
                            (pageChange)="onPageChange($event)"></ngb-pagination>
        </div>
    </ng-container>
    <div class="w-100 float-left" *ngIf="switchPage == 'getSwitchableUsers'" (click)="closeEmployeeFilter()">
        <div class="w-100 float-left d-flex align-items-center b-b pb-3">
            <h5 class="medium float-left mb-0"> {{'addEmployees' | translate}} </h5>
            <div style="flex-grow: 1;"></div>
            <button class="btn btn-secondary">
                <i class="fa fa-arrow-left mr-sm-2"></i> {{'back' | translate}}
            </button>
        </div>
        <div class="w-100 float-left my-4">
            <h6 class="medium mb-3"> {{'chooseEmpAdd' | translate}} </h6>
            <div class="form-group col-lg-3 col-md-3 float-left" (click)="everyone()">
                <input type="radio" id="everyone" name="radio-group" checked>
                <label for="everyone" class="normal"> {{'includeEveryOne' | translate}} </label>
            </div>

            <div class="form-group col-lg-3 col-md-3 float-left" (click)="everyOneIn()">
                <input type="radio" id="except" name="radio-group">
                <label for="except" class="normal"> {{'includeEveryOneExpect' | translate}} </label>
            </div>

            <div class="form-group col-lg-3 col-md-3 float-left" (click)="everyOneIn()">
                <input type="radio" id="everyOneIn" name="radio-group">
                <label for="everyOneIn" class="normal"> {{'includeEveryoneIn' | translate}} </label>
            </div>
            <div class="col-lg-10 col-md-10 float-left mb-2" *ngIf="empArea == 3">
                <p class="text-primary float-right pl-3 m-0 cursor" (click)="getEveryEmployee(false)">
                    {{'doNotEmpCode' | translate}} </p>
                <textarea class="form-control w-100" rows="5"></textarea>
                <span class="text-12x"> {{'enterEmpCodeWithSeparator' | translate}} </span>
            </div>
        </div>

        <button class="btn btn-primary float-right">{{'add' | translate}}</button>
        <button class="btn btn-secondary float-right mr-4" (click)="rolesBack()">{{'cancel' | translate }}</button>
    </div>
</ng-container>


// WEBPACK FOOTER //
// ./src/app/switchUser/switchUser.html